import { Route, Routes, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Sidebar from "../components/Sidebar";
import MedicamentSuggestions from "../pages/MedicamentSuggestions";
import Medicaments from "../pages/Medicaments";
import CosmeticList from "../pages/MedicamentsCosmetics"
import MedicamentVariantList from "../pages/MedicamentVariantList";
import ReportProblems from "../pages/Problems";
import InteractionList from "../pages/InteractionsList";
import PctMedicamentList from "../pages/PctMedicamentList";
import Pathologies from "../pages/Pathologies";
import DermoMedicineList from "../pages/DermoMedicineList";
import DermoPlaints from "../pages/DermoPlaints";
import CountrySwitcher from "../components/CountrySwitcher";
import AideTranslations from "../pages/AideTranslations";

const Authenticated = () => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', margin: '20px' }}>
        <Sidebar />
        <CountrySwitcher />
      </div>
      <div style={{ display: 'flex' }}>
        <div style={{ marginLeft: '40px', width: '100%', padding: '20px' }}>
        <Routes>
          <Route path="/" element={<Navigate replace to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/suggestions" element={<MedicamentSuggestions />} />
          <Route path="/medicaments" element={<Medicaments />} />
          <Route path="/cosmetic" element={<CosmeticList />} />
          <Route path="/interactions" element={<InteractionList />} />
          <Route path="/pct_meds" element={<PctMedicamentList />} />
          <Route path="/medicaments/:medicamentId/:specialite/variants" element={<MedicamentVariantList />} />
          <Route path="/problems" element={<ReportProblems/>}/>
          <Route path="/pathologies" element={<Pathologies />} />
          <Route path="/dermo-medicines" element={<DermoMedicineList />} />
          <Route path="/dermo-plaints" element={<DermoPlaints />} />
          <Route path="/translations-fr-ar" element={<AideTranslations />} />
        </Routes>
        </div>
      </div>
    </div>
    
  );
};
export default Authenticated;
